(function () {
  const HOST_SELECTOR = 'shopify-forms-embed';
  const SUBMIT_SELECTOR = '[data-testid="btn-form-submit"]';

  const applyStyles = (host) => {
    // Override CSS variables on the host — they pierce the shadow DOM boundary
    host.style.setProperty('--button-border-radius', '40px');
    host.style.setProperty('--container-max-w', '100%');
    host.style.setProperty('--inline-container-max-width', '100%');
    host.style.setProperty('--app-embed-padding-x', '0px');

    // Also set inline style directly on the button via the open shadow root
    if (host.shadowRoot) {
      host.shadowRoot.querySelectorAll(SUBMIT_SELECTOR).forEach((button) => {
        button.style.setProperty('border-radius', '40px', 'important');
      });
    }
  };

  const applyToAll = () => {
    document.querySelectorAll(HOST_SELECTOR).forEach(applyStyles);
  };

  applyToAll();

  const observer = new MutationObserver(applyToAll);
  observer.observe(document.body, { childList: true, subtree: true });
})();
